import React, { useLayoutEffect } from 'react'
import Footer from '../Component/Footer/Footer'
import FooterNav from '../Component/AppComponent/Footer/FooterNav'

const PrivacyPolicy = () => {
      useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    return (
        <div>
            <div className='Terms-and-conditions-page'>
                <div className='container'>
                    <div className='Terms-and-conditions-page'>
                        <h2>Privacy Policy</h2>
                        <p>At Woodsy, we value your privacy and are committed to safeguarding your personal information. This Privacy Policy outlines how we collect, use, and protect your data when you interact with our website <a href='https://woodsy.co.in' target="blank">(https://woodsy.co.in)</a></p>

                        <h3>Information We Collect</h3>
                        <p><strong>We collect personal information to process orders and improve your experience. This includes:</strong></p>
                        <p>Name, email, phone number</p>
                        <p>Shipping and billing addresses</p>
                        <p>Payment details (securely processed)</p>
                        <p>IP address, browser and device information</p>
                        <p>Website usage data and cookies</p>

                        <h3>Use of Your Information</h3>
                        <p><strong>The data we collect is used to:</strong></p>
                        <p>Process purchases and deliver products</p>
                        <p>Provide updates on your order and respond to inquiries</p>
                        <p>Enhance website performance and functionality</p>
                        <p>Detect and prevent misuse or fraudulent activity</p>
                        <p>Meet legal or compliance obligations</p>
                        <p>We never sell or rent your personal data.</p>

                        <h3>Account and Personal Information</h3>
                        <p>Users are required to provide accurate, complete, and updated personal information to create an account and place orders. This includes your name, contact number, email address, and shipping address. You are responsible for maintaining the confidentiality of your login credentials. Any actions taken under your account will be considered your responsibility, whether or not you authorized them.</p>
                        <p>If we suspect that any information provided is false, misleading, or outdated, we reserve the right to suspend or block access to your account without prior notice.</p>

                        <h3>Sharing of Information</h3>
                        <p>Your information may be shared only as necessary to operate our business—such as processing payments, delivering orders, or gaining insights to improve services. All information is handled securely and responsibly.</p>

                        <h3>Cookies and Tracking</h3>
                        <p><strong>We use cookies and similar tools to:</strong></p>
                        <p>Maintain your cart and session state</p>
                        <p>Personalize your browsing experience</p>
                        <p>Gather analytics to improve performance</p>
                        <p>You can control cookie preferences via your browser settings. Disabling cookies may limit some website features.</p>

                        <h3>Data Security</h3>
                        <p><strong>We prioritize security through:</strong></p>
                        <p>SSL encryption</p>
                        <p>Secure hosting and firewall protection</p>
                        <p>Access control and monitoring protocols</p>
                        <p>Sensitive data like payment information is processed securely and never stored directly by Woodsy.</p>

                        <h3>Data Retention</h3>
                        <p>We retain personal data only as long as necessary to fulfill orders, provide support, comply with regulations, or carry out permitted marketing activities with your consent.</p>

                        <h3>Your Rights</h3>
                        <p><strong>You have the right to:</strong></p>
                        <p>Access your personal information</p>
                        <p>Correct or update inaccurate data</p>
                        <p>Request deletion of your information, unless retention is required</p>
                        <p>Withdraw consent from marketing communications</p>
                        <p>For any privacy-related inquiries, feel free to contact Woodsy directly. Your trust is important to us, and we’re dedicated to handling your information with care and transparency.</p>
                    </div>
                </div>
            </div>

            <Footer />
            <FooterNav />
        </div>
    )
}

export default PrivacyPolicy
